export default __webpack_public_path__ + "static/media/1616.9762fd53.png";